import getLocationAsync from "../services/location/location";
import { store } from "./store";
import { setLocation } from "../features/utils/utilsSlice";

export async function initLocationOnce(): Promise<void> {
  const current = store.getState().utils.location;
  if (typeof current !== "undefined" && current !== null) return;

  const res = await getLocationAsync();
  if (!res) return;

  const {
    city,
    latitude,
    longitude,
    state_prov,
    calling_code,
    country_flag,
    country_name,
    country_code2,
    country_code3,
  } = res;

  store.dispatch(
    setLocation({
      city,
      latitude,
      longitude,
      state_prov,
      calling_code,
      country_flag,
      country_name,
      country_code2,
      country_code3,
    })
  );
}


